
import React, { useMemo } from 'react';
import { AppButton, Box, FiservCardInterface, FiservCardStatusEnum, LockIcon, Preloader, UnlockIcon } from '@common-fe/common-fe';

import { useIsLockCardPurseAvailable } from '@/modules/featureFlags';

import { CardStatusActionWrap } from '../ChangeStatusCardModal.styles';

import CardActionCardHeader from './CardActionCardHeader';

interface CardLockUnlockActionCardProps {
  card: FiservCardInterface;
  loadingButton: boolean;
  onOpenLockModal: () => void;
  onOpenLockUnlockCardModal: () => void;
}

const LOCKED_STATUSES = [FiservCardStatusEnum.FROZEN, FiservCardStatusEnum.PENDING_FROZEN];

const CardLockUnlockActionCard: React.FC<CardLockUnlockActionCardProps> = ({
  card,
  loadingButton,
  onOpenLockModal,
  onOpenLockUnlockCardModal,
}) => {
  const isLockCardPurseAvailable = useIsLockCardPurseAvailable();
  const isCardLocked = useMemo(() => LOCKED_STATUSES.includes(card.status), [card.status]);

  const buttonLabel = useMemo(() => {
    if (!isLockCardPurseAvailable) {
      return 'Update Card Access';
    }
    return isCardLocked ? 'Unlock Card' : 'Lock Card';
  }, [isLockCardPurseAvailable, isCardLocked]);

  const title = isLockCardPurseAvailable ? buttonLabel : 'Lock/Unlock Card';
  const description = isLockCardPurseAvailable
    ? (
      <>
        You can unlock this card
        <br />
        at any time.
      </>
    )
    : (
      <>
        Manage card and
        <br />
        account access.
      </>
    );

  return (
    <Box>
      <CardStatusActionWrap
        background="canvas"
        round="container1Round"
        border={{ color: 'border2', size: 'small' }}
      >
        <CardActionCardHeader
          icon={isCardLocked ? (
            <UnlockIcon size="xlarge" color="iconAccent" />
          ) : (
            <LockIcon size="xlarge" color="iconAccent" />
          )}
          title={title}
          description={description}
          descriptionLineHeight="20px"
        />
        <AppButton
          buttonType="primary"
          type="submit"
          width="100%"
          testId="card-lock-unlock-action-card_button"
          style={{ height: '40px', paddingInline: '12px' }}
          disabled={loadingButton}
          onClick={isLockCardPurseAvailable ? onOpenLockUnlockCardModal : onOpenLockModal}
        >
          {loadingButton ? (
            <Box width="100%" align="center">
              <Preloader color="white" />
            </Box>
          ) : (
            buttonLabel
          )}
        </AppButton>
      </CardStatusActionWrap>
    </Box>
  );
};

export default CardLockUnlockActionCard;
